import { getEnv } from 'ecx.saigon.ui.common';

/**
 * Return the URL for a quote within the order
 *
 * @param acceptedQuoteId
 * @param quoteId
 * @param application
 * @returns {Promise<string|*>}
 */
export default async function getFurthestQuoteRoute(
  acceptedQuoteId,
  quoteId,
  application = {}
) {
  const env = await getEnv();
  const metaData = application.metaData || {};

  if (acceptedQuoteId) {
    return env.VUE_APP_CREDIT_CHECK_ROUTE;
  }

  return quoteId
    ? `${env.VUE_APP_QUOTE_ROUTE}/${quoteId}`
    : env.VUE_APP_QUOTE_ROUTE;
}
